var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SvgIconBase',{attrs:{"svgImgPath":require(("./../../assets/weather_icons/" + _vm.WeatherIconName + ".svg")),"Width":_vm.width,"Height":_vm.heigth}})}
var staticRenderFns = []

export { render, staticRenderFns }